// extracted by mini-css-extract-plugin
export default {"NotFoundSectionBox":"NotFound_NotFoundSectionBox__30GAL"};